export class K8sEventObservation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "reason",
            "baseName": "reason",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": ""
        },
        {
            "name": "lastTimestamp",
            "baseName": "lastTimestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "involvedObjectKind",
            "baseName": "involvedObjectKind",
            "type": "string",
            "format": ""
        },
        {
            "name": "involvedObjectName",
            "baseName": "involvedObjectName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return K8sEventObservation.attributeTypeMap;
    }
    constructor() {
    }
}
